import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { MainMenu } from '../menu-item.interface';

export const MENU_PROCESSOR: InjectionToken<IMenuProcessor> = new InjectionToken('MENU_PROCESSOR');

/**
 * Implement this interface to modify the menu in any way when it's being loaded (i.e. sort menu items / remove items based on permission checks etc.)
 */
export interface IMenuProcessor {
	process(menu: MainMenu): Observable<MainMenu>;
}
